// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1megB","newExpiryDate":"styles_newExpiryDate__1Vwr7","footer":"styles_footer__30LQq"};